import React from 'react';
import styled from 'styled-components';
import CalculatorPro from './CalculatorPro';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  z-index: 1500;
  overflow-y: auto;
  padding: 2rem 1rem;
`;

const ModalContent = styled.div`
  background: #f0f0f0;
  border-radius: 8px;
  width: 100%;
  max-width: 1200px;
  max-height: calc(100vh - 4rem);
  overflow-y: auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  position: relative;
`;

/**
 * CalculatorEditModal - Modal wrapper for editing order articles using CalculatorPro
 *
 * @param {Object} article - The article to edit (from groupLinesIntoArticles)
 * @param {Object} order - The full order object
 * @param {Function} onSave - Callback when save is successful, receives (editResult)
 * @param {Function} onClose - Callback to close the modal
 */
const CalculatorEditModal = ({ article, order, onSave, onClose }) => {
  // Handle click on overlay to close
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  // Handle save from CalculatorPro
  const handleSaveEdit = async (editResult) => {
    console.log('CalculatorEditModal received save result:', editResult);

    try {
      // Call the parent onSave with the result
      if (onSave) {
        const saveResult = await onSave(editResult);
        // Keep modal open when parent reports a failed save
        if (saveResult === false) {
          return;
        }
      }

      // Close the modal after successful save
      onClose();
    } catch (error) {
      // Parent handler already shows user-facing error message.
      // Keep modal open so the user can retry/fix data.
      console.error('CalculatorEditModal save failed:', error);
    }
  };

  return (
    <ModalOverlay onClick={handleOverlayClick}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <CalculatorPro
          editMode={true}
          editData={article}
          editOrder={order}
          onSaveEdit={handleSaveEdit}
          onCancelEdit={onClose}
        />
      </ModalContent>
    </ModalOverlay>
  );
};

export default CalculatorEditModal;
